import CallForPapers from "../components/CallForPapers";


function Callforpapers() {
  return (
    <>
      <div className="margin layout8 ">
     
<CallForPapers></CallForPapers>
      </div>
    </>
  );
}

export default Callforpapers;
